import CSS from "./static/css/loopAnimation.module.css";

const LoopAnimation = () => {
    return (
        <div className={CSS.loader} />
    )
}

export default LoopAnimation;